module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-loading', {
    attrs: {
      "color": "#093937",
      "isLoading": _vm.loading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "images-section"
  }, [_c('draggable', {
    staticClass: "draggable-container",
    attrs: {
      "group": "image",
      "sort": true
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "change": _vm.reorder
    },
    model: {
      value: (_vm.imagesList),
      callback: function($$v) {
        _vm.imagesList = $$v
      },
      expression: "imagesList"
    }
  }, _vm._l((_vm.imagesList), function(image, index) {
    return _c('div', {
      key: image.id,
      staticClass: "col-12 col-md-4 images mb-50"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": image.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "visuel-wrapper resp-checklists-img-box"
    }, [_c('div', {
      staticClass: "checklists-image-masque"
    }, [_c('button', {
      staticClass: "btn btn-block btn-warning waves-effect waves-classic waves-effect waves-classic",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteImage(image, index, _vm.type)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t("button.delete")) + "\n          ")])])]), _vm._v(" "), (_vm.type !== 'slider') ? _c('textarea-autosize', {
      ref: (_vm.type + "-" + index),
      refInFor: true,
      staticClass: "form-control edit-image-label",
      attrs: {
        "name": "the-space-image-name",
        "autofocus": "autofocus",
        "cols": "30",
        "rows": "1"
      },
      model: {
        value: (image.label),
        callback: function($$v) {
          _vm.$set(image, "label", $$v)
        },
        expression: "image.label"
      }
    }) : _vm._e()], 1)
  }))], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-378a4098"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/rentals/detail/VrboConfigurationTab/ImagesBox.vue
// module id = 1328
// module chunks = 0